package com.merkost.handpass.admin.contract

sealed interface AsyncSection<out T> {
    data object Loading : AsyncSection<Nothing>
    data class Loaded<T>(val value: T) : AsyncSection<T>
    data class Failed(val message: String) : AsyncSection<Nothing>
}
